import React from 'react';

import { TextAreaField, MCButton, CheckboxField, Spinner } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import constants from 'src/constants';

import { lang, remCss } from 'src/helpers';
import ShortInfo from './ShortInfo';

const userStatuses = constants.general.userStatus;

class AcceptDeclineForm extends BaseComponent {
  apiStateId = 'updateStatus';
  componentDidMount() {
    const { model, status } = this.props;

    this.apiStateId = status === 'removed' ? 'remove' : 'updateStatus';

    model.setStateSilent({ reason: '' });
    model.baseSubscribe(this.subscription);
  }

  componentWillUnmount() {
    const { model } = this.props;
    model.unsubscribe(this.subscription);
  }

  submit = () => {
    const { actionStatus, hide, item, model, hasReason = true, afterApproved } = this.props;
    if (actionStatus === 'removed')
      return model.remove(item.id, (err, res, success) => {
        if (success) {
          hide();
        } else {
          alert(`error: ${err}`);
        }
      });

    model.updateStatus(
      item,
      actionStatus,
      hasReason ? model.input('reason') : '',
      (err, data, success) => {
        if (!success) return;
        hide();
        switch (actionStatus) {
          case userStatuses.approved:
            if (afterApproved) {
              afterApproved();
            }
            if (Array.isArray(data)) {
              data.map((item) => model.removeItem(item));
            } else model.removeItem(data);
            break;
          default:
            if (Array.isArray(data)) {
              data.map((item) => model.updateItem(item));
            } else model.updateItem(data);
            break;
        }
      }
    );
  };

  selectItem = (value) => {
    const { model } = this.props;
    model.setState({
      linkAccounts: model.state.linkAccounts.map((item) => ({
        ...item,
        disabled: item.id === value ? !item.disabled : item.disabled
      }))
    });
  };

  render() {
    const { actionStatus, closeBtn, item, model, hasReason = true, isLinkAccounts } = this.props;
    const apiStateId = this.apiStateId;
    const { invalid, loading } = model.getApiState(apiStateId);
    const list = model.state.linkAccounts;
    const selectedIds = model.state.linkAccounts?.filter((item) => !item.disabled);
    const { loading: listLoading } = model.getApiState('linkAccounts');

    return (
      <div className={'mc-popup-contain'} style={{ maxWidth: remCss(500) }}>
        <form className='mc-modal-body mc-flex-col' onSubmit={this.submit}>
          <ShortInfo user={item} verticalCenter={true} large />
          {hasReason && (
            <TextAreaField
              template={6}
              rows={4}
              name={'reason'}
              placeholder={'Reason'}
              value={model.input('reason')}
              onChange={(n, v) => {
                model.resetApiState(apiStateId);
                model.handleChange(n, v);
              }}
              invalid={invalid}
              disabled={loading}
            />
          )}
          {closeBtn}
          {!isLinkAccounts ? null : listLoading ? (
            <Spinner />
          ) : (
            list &&
            list.length > 0 && (
              <div className={'mc-flex-5-col'}>
                <div className={'mc-flex mc-mt10'} style={{ minHeight: remCss(55) }}>
                  <CheckboxField
                    template={'2'}
                    checked={list.length === selectedIds.length}
                    onChange={() => {
                      if (list.length !== selectedIds.length)
                        model.setState({
                          linkAccounts: model.state.linkAccounts.map((item) => ({
                            ...item,
                            disabled: false
                          }))
                        });
                    }}
                  />
                  <div
                    className={'mc-text-520 mc-pointer'}
                    onClick={() => {
                      if (list.length !== selectedIds.length)
                        model.setState({
                          linkAccounts: model.state.linkAccounts.map((item) => ({
                            ...item,
                            disabled: false
                          }))
                        });
                    }}
                  >
                    {lang.t('All doctor accounts')}
                  </div>
                </div>
                {list.map((u) => (
                  <div
                    key={u.id}
                    className={'mc-flex mc-pointer'}
                    style={{ minHeight: remCss(55) }}
                  >
                    <CheckboxField
                      template={'2'}
                      checked={!u.disabled}
                      onChange={() => {
                        this.selectItem(u.id);
                      }}
                    />
                    <ShortInfo
                      user={u}
                      onClick={() => {
                        this.selectItem(u.id);
                      }}
                    />
                  </div>
                ))}
              </div>
            )
          )}
        </form>
        <div className='mc-modal-footer'>
          <div className={'mc-grow'} />

          <MCButton
            light
            primary={actionStatus === userStatuses.approved}
            secondary={actionStatus !== userStatuses.approved}
            medium
            radius
            onClick={this.submit}
          >
            {loading
              ? lang.t('Processing...')
              : lang.t(
                  actionStatus === userStatuses.approved
                    ? 'Accept'
                    : actionStatus === 'removed'
                      ? 'Remove'
                      : actionStatus === userStatuses.declined &&
                          item.status === userStatuses.pending
                        ? 'Decline'
                        : 'More info'
                )}
          </MCButton>
        </div>
      </div>
    );
  }
}

export default AcceptDeclineForm;
